export default __webpack_public_path__ + "static/media/pdf-icon.b1ed3f48.svg";